// Formats d'affichage. Fuseau des Antilles, comme A97 Hub.
const FUSEAU = 'America/Martinique';

export const nomComplet = (p, prefixe = '') => {
  if (!p) return '';
  const prenom = p[`${prefixe}prenom`];
  const nom = p[`${prefixe}nom`];
  return [prenom, nom].filter(Boolean).join(' ');
};

export const initiales = (prenom, nom) =>
  `${(prenom || '').charAt(0)}${(nom || '').charAt(0)}`.toUpperCase() || '?';

// Sans accents ni majuscules, pour chercher « ines » dans « Inès ».
export const simplifier = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

// Une colonne DATE arrive en 'AAAA-MM-JJ' : on la lit comme un jour, sans
// passer par Date (sinon les Antilles voient la veille).
export const dateCourte = (jour) => (jour ? jour.split('-').reverse().join('/') : '');

export const aujourdhui = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: FUSEAU }).format(new Date()); // AAAA-MM-JJ

export const enRetard = (jour, statut) => !!jour && statut !== 'termine' && jour < aujourdhui();

export const horodatage = (iso) => (iso
  ? new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: FUSEAU })
  : '');

export function ilYA(iso) {
  if (!iso) return '';
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'à l’instant';
  if (s < 3600) return `il y a ${Math.floor(s / 60)} min`;
  if (s < 86400) return `il y a ${Math.floor(s / 3600)} h`;
  if (s < 7 * 86400) return `il y a ${Math.floor(s / 86400)} j`;
  return horodatage(iso);
}

export const pourcentage = (fait, total) => (total ? Math.round((100 * fait) / total) : 0);

// Taille d'un fichier lisible : « 820 o », « 14 ko », « 2,3 Mo ».
export function taille(octets) {
  if (octets < 1024) return `${octets} o`;
  if (octets < 1024 * 1024) return `${Math.round(octets / 1024)} ko`;
  return `${(octets / (1024 * 1024)).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Mo`;
}
